import { FC } from "react";
import { IShimmerColors, Shimmer, ShimmerElementsGroup, ShimmerElementType } from "@fluentui/react";

interface ShimmerBarProps {
  width: number;
  height: number;
  shimmerColors?: IShimmerColors;
  isDataLoaded?: boolean;
}

// "bar" is the term for each individual shimmering rectangle —
// a single line element rendered by Fluent's <Shimmer>.

export const ShimmerBar: FC<ShimmerBarProps> = ({ width, height, shimmerColors, isDataLoaded }) => (
  <Shimmer
    isDataLoaded={isDataLoaded}
    shimmerColors={shimmerColors}
    customElementsGroup={
      <ShimmerElementsGroup shimmerElements={[{ type: ShimmerElementType.line, width, height }]} />
    }
  />
);
